/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ComputeLogSource1 = {
  System: "system",
  User: "user",
} as const;
export type ComputeLogSource1 = ClosedEnum<typeof ComputeLogSource1>;

export const Stream = {
  Stdout: "stdout",
  Stderr: "stderr",
} as const;
export type Stream = ClosedEnum<typeof Stream>;

export type ComputeLog = {
  id: string;
  instanceRank?: number | undefined;
  message: string;
  source: ComputeLogSource1;
  stream: Stream;
  timestamp: Date;
};

/** @internal */
export const ComputeLogSource1$inboundSchema: z.ZodNativeEnum<
  typeof ComputeLogSource1
> = z.nativeEnum(ComputeLogSource1);
/** @internal */
export const ComputeLogSource1$outboundSchema: z.ZodNativeEnum<
  typeof ComputeLogSource1
> = ComputeLogSource1$inboundSchema;

/** @internal */
export const Stream$inboundSchema: z.ZodNativeEnum<typeof Stream> = z
  .nativeEnum(Stream);
/** @internal */
export const Stream$outboundSchema: z.ZodNativeEnum<typeof Stream> =
  Stream$inboundSchema;

/** @internal */
export const ComputeLog$inboundSchema: z.ZodType<
  ComputeLog,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  instance_rank: z.number().int().optional(),
  message: z.string(),
  source: ComputeLogSource1$inboundSchema,
  stream: Stream$inboundSchema,
  timestamp: z.string().datetime({ offset: true }).transform(v => new Date(v)),
}).transform((v) => {
  return remap$(v, {
    "instance_rank": "instanceRank",
  });
});
/** @internal */
export type ComputeLog$Outbound = {
  id: string;
  instance_rank?: number | undefined;
  message: string;
  source: string;
  stream: string;
  timestamp: string;
};

/** @internal */
export const ComputeLog$outboundSchema: z.ZodType<
  ComputeLog$Outbound,
  z.ZodTypeDef,
  ComputeLog
> = z.object({
  id: z.string(),
  instanceRank: z.number().int().optional(),
  message: z.string(),
  source: ComputeLogSource1$outboundSchema,
  stream: Stream$outboundSchema,
  timestamp: z.date().transform(v => v.toISOString()),
}).transform((v) => {
  return remap$(v, {
    instanceRank: "instance_rank",
  });
});

export function computeLogToJSON(computeLog: ComputeLog): string {
  return JSON.stringify(ComputeLog$outboundSchema.parse(computeLog));
}
export function computeLogFromJSON(
  jsonString: string,
): SafeParseResult<ComputeLog, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeLog$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeLog' from JSON`,
  );
}
